// *** REACT components
import React, { useContext } from 'react'
// *** Core components
import GridContainer from "components/Grid/GridContainer.js"
import GridItem from "components/Grid/GridItem.js"
import TextField from '@material-ui/core/TextField'
import { makeStyles } from "@material-ui/core/styles"
import InputAdornment from '@material-ui/core/InputAdornment'
import IconButton from '@material-ui/core/IconButton';
import Icon from "@material-ui/core/Icon"
// import Box from "@material-ui/core/Box";
import {ThemeProvider} from "@material-ui/core/styles";
import{createMuiTheme} from "@material-ui/core/styles";
// import { verde } from "@material-ui/core/colors/lightGreen";
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
// *** Contexto
import { UsuarioContext } from 'config/context/UsuarioProvider'
// *** Estilos
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js"
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'

import Nserie from "assets/img/Nserie.jpg";
// import { VisibilityOff } from '@material-ui/icons'


const useStyles = makeStyles(basicsStyle);
const theme = createMuiTheme({
  palette:{
    primary:{
      main:'#a1c330'
    }
  }
})

export default function DatosPersonales() {
  const { usuario, setusuario, planUser } = useContext(UsuarioContext);
  const [openHelp, setOpenHelp] = React.useState(false);
  const classes = useStyles()
  var direccionRef = React.createRef()
  var celularRef = React.createRef()
  var numserieRef = React.createRef()
  var nombresRef = React.createRef()
  var apellidosRef = React.createRef()
  var rutRef = React.createRef()
  var emailRef = React.createRef()



  ValidatorForm.addValidationRule('isTruthy', value => value);
  ValidatorForm.addValidationRule('isRut', (value) => {
    let rutFormateado = formatRut(value, false)
    return rutEsValido(rutFormateado)
  })
  function formatRut(value, useThousandsSeparator) {
    var rutAndDv = splitRutAndDv(value)
    var cRut = rutAndDv[0]; var cDv = rutAndDv[1]
    if (!(cRut && cDv)) { return cRut || value; }
    var rutF = ""
    var thousandsSeparator = useThousandsSeparator ? "." : ""
    while (cRut.length > 3) {
      rutF = thousandsSeparator + cRut.substr(cRut.length - 3) + rutF
      cRut = cRut.substring(0, cRut.length - 3)
    }
    return cRut + rutF + "-" + cDv
  }

  function splitRutAndDv(rut) {
    var cValue = clearFormat(rut);
    if (cValue.length === 0) { return [null, null]; }
    if (cValue.length === 1) { return [cValue, null]; }
    var cDv = cValue.charAt(cValue.length - 1);
    var cRut = cValue.substring(0, cValue.length - 1);
    return [cRut, cDv];
  }
  function clearFormat(value) {
    return value.replace(/[\.\-]/g, "");
  }
  function rutEsValido(rut) {
    if (!rut || rut.trim().length < 3) return false;
    const rutLimpio = rut.replace(/[^0-9kK-]/g, "");

    if (rutLimpio.length < 3) return false;

    const split = rutLimpio.split("-");
    if (split.length !== 2) return false;

    const num = parseInt(split[0], 10);
    const dgv = split[1];

    const dvCalc = calculateDV(num);
    return dvCalc === dgv.toUpperCase();
  }
  function calculateDV(rut) {
    const cuerpo = `${rut}`;
    // Calcular Dígito Verificador
    let suma = 0;
    let multiplo = 2;

    // Para cada dígito del Cuerpo
    for (let i = 1; i <= cuerpo.length; i++) {
      // Obtener su Producto con el Múltiplo Correspondiente
      const index = multiplo * cuerpo.charAt(cuerpo.length - i);

      // Sumar al Contador General
      suma += index;

      // Consolidar Múltiplo dentro del rango [2,7]
      if (multiplo < 7) {
        multiplo += 1;
      } else {
        multiplo = 2;
      }
    }

    // Calcular Dígito Verificador en base al Módulo 11
    const dvEsperado = 11 - (suma % 11);
    if (dvEsperado === 10) return "K";
    if (dvEsperado === 11) return "0";
    return `${dvEsperado}`;
  }

  return (
    <div>
      {<div>
        <Dialog onClose={e => setOpenHelp(false)} aria-labelledby="customized-dialog-title" open={openHelp}>
          <DialogTitle id="customized-dialog-title" onClose={e => setOpenHelp(false)}>
            ¿Qué es el Número de Serie?
          </DialogTitle>
          <DialogContent dividers>
            <Typography gutterBottom>
              El número de serie o de documento es un número único que está impreso en tu cédula de identidad. Este dato es muy importante para comprar tu certificado en FirmaDox. Así verificamos tus datos y podemos continuar con el proceso de registro.
            </Typography>
            <GridContainer justify="center">
              <img src={Nserie} alt="..."></img>
            </GridContainer>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={e => setOpenHelp(false)} color="primary">
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      }
      <div className={classes.title} style={{ textAlign: "center",marginTop: "0px",marginBottom: "0px"}}>
        <h3 style={{fontWeight: "400"}}>Ingreso de Datos Personales</h3>
      </div>
      <GridContainer>
      <ThemeProvider theme={theme}>
        <GridItem xs={12} sm={6} md={6} lg={6} style={{ paddingTop: 10 }}>
          {planUser === "CFAO" ?
            <TextField
              fullWidth
              label="Nombre"
              id="txtNombre"
              value={usuario.nombres}
            />
            : null}
          {planUser === "CFES" || planUser === "CFEA" ?
            <TextValidator
              fullWidth
              autoFocus
              inputProps={{
                maxLength: 50
              }}
              ref={nombresRef}
              onBlur={e => nombresRef.current.validate(e.target.value)}
              label="Nombre"
              id="txtNombre"
              value={usuario.nombres}
              onChange={e => setusuario({ ...usuario, nombres: e.target.value.replace(/[^A-Za-z ñÑÁÉÍÓÚáéíóú]+/g, "").toUpperCase() })}
              validators={['minStringLength:3', 'maxStringLength:50', "required"]}
              errorMessages={['Campo requerido o mínimo 3 y máximo 50 caracteres']}
            />
            : null}
        </GridItem>
        <GridItem xs={12} sm={6} md={6} lg={6} style={{ paddingTop: 10 }}>
          {planUser === "CFAO" ?
            <TextField
              fullWidth
              label="Apellidos"
              id="txtApellidos"
              value={usuario.apellidos}
            />
            : null}
          {planUser === "CFES" || planUser === "CFEA" ?
            <TextValidator
              fullWidth
              inputProps={{
                maxLength: 50
                , style: { textTransform: 'uppercase' }
              }}
              ref={apellidosRef}
              onBlur={e => apellidosRef.current.validate(e.target.value)}
              label="Apellidos"
              id="txtApellidos"
              value={usuario.apellidos}
              onChange={e => setusuario({ ...usuario, apellidos: e.target.value.replace(/[^A-Za-z ñÑÁÉÍÓÚáéíóú]+/g, "").toUpperCase() })}
              validators={['minStringLength:3', 'maxStringLength:50', "required"]}
              errorMessages={['Campo requerido o mínimo 3 y máximo 50 caracteres']}
            />
            : null}
        </GridItem>
        <GridItem xs={12} sm={6} md={6} lg={6} style={{ paddingTop: 30 }}>
          {planUser === "CFAO" ?
            <TextField
              fullWidth
              label="RUN"
              id="txtRUT"
              value={usuario.rut}
            />
            : null}
          {planUser === "CFES" || planUser === "CFEA" ?
            <TextValidator
              fullWidth
              inputProps={{
                maxLength: 12
                , style: { textTransform: 'uppercase' }
              }}
              ref={rutRef}
              onBlur={e => rutRef.current.validate(e.target.value)}
              id="txtRUT"
              label="RUN"
              type="RUT"
              value={usuario.rut}
              onChange={e => setusuario({ ...usuario, rut: formatRut(e.target.value.replace(/[^0-9kK-]/g, "").toUpperCase(), true) })}
              validators={["isTruthy", 'isRut', "required"]}
              errorMessages={['Campo requerido o formato incorrecto','Campo con formato incorrecto','Campo requerido']}
            />
            : null}

        </GridItem>
        {planUser === "CFES" ?
          <GridItem xs={12} sm={6} md={6} lg={6} style={{ paddingTop: 30 }}>
            <TextValidator
              fullWidth
              ref={numserieRef}
              onBlur={e => numserieRef.current.validate(e.target.value)}
              id="txtNoSerie"
              label="No. de Serie"
              value={usuario.numserie}
              onChange={e => setusuario({ ...usuario, numserie: e.target.value.toUpperCase() })}
              validators={['minStringLength:9', 'maxStringLength:10', "required"]}
              errorMessages={['Campo requerido o mínimo 9 y máximo 10 caracteres']}
              inputProps={{
                maxLength: 10
                , style: { textTransform: 'uppercase' }
                , endAdornment:
                  <InputAdornment
                    position="end"
                    className={classes.inputAdornment}
                  >
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={e => openHelp ? setOpenHelp(false) : setOpenHelp(true)}
                    >
                      <Icon className={classes.inputAdornmentIcon}>
                        live_help
                      </Icon>
                    </IconButton>
                  </InputAdornment>
              }}

            />
          </GridItem>
          : null}

        <GridItem xs={12} sm={6} md={6} lg={6} style={{ paddingTop: 30 }}>
          {planUser === "CFAO" ?
            <TextField
              fullWidth
              label="Correo Electrónico"
              id="txtEmail"
              value={usuario.email}
              onChange={e => setusuario({ ...usuario, email: e.target.value.toUpperCase() })}
            />
            : null}
          {planUser === "CFES" || planUser === "CFEA" ?
            <TextValidator
              fullWidth
              inputProps={{
                maxLength: 100
                , style: { textTransform: 'uppercase' }
              }}
              ref={emailRef}
              onBlur={e => emailRef.current.validate(e.target.value)}
              id="txtEmail"
              label="Correo Electrónico"
              value={usuario.email}
              onChange={e => setusuario({ ...usuario, email: e.target.value.toUpperCase() })}
              validators={["isTruthy", "isEmail", "required"]}
              errorMessages={['Campo requerido y con formato correo','Campo no tiene formato de correo','Campo requerido']}
            />
            : null}
        </GridItem>
        <GridItem xs={12} sm={6} md={6} lg={6} style={{ paddingTop: 30 }}>
          <TextValidator
            fullWidth
            ref={celularRef}
            onBlur={e => celularRef.current.validate(e.target.value)}
            id="txtCelular"
            label="Teléfono"
            type="number"
            onInput={(e) => { e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 9) }}
            value={usuario.celular}
            onChange={e => setusuario({ ...usuario, celular: e.target.value })}
            //validators={["isTruthy", "required"]}
            validators={['minStringLength:9', 'maxStringLength:9', "required"]}
            errorMessages={['Campo requerido']}
            InputProps={{
              startAdornment: <InputAdornment position="start">+56-</InputAdornment>
              , style: { textTransform: 'uppercase' }
            }}

          />
        </GridItem>
        <GridItem xs={12} sm={12} md={12} lg={12} style={{ paddingTop: 30 }}>
          <TextValidator
            fullWidth
            inputProps={{
              maxLength: 100
              , style: { textTransform: 'uppercase' }
            }}
            ref={direccionRef}
            onBlur={e => direccionRef.current.validate(e.target.value)}
            id="txtDirección"
            label="Dirección"
            value={usuario.direccion}
            onChange={e => setusuario({ ...usuario, direccion: e.target.value.replace(/[^A-Za-z0-9 #ºÑñ]+/g, "").toUpperCase() })}
            validators={['minStringLength:5', 'maxStringLength:100', "required"]}
            errorMessages={['Campo requerido']}
          />

        </GridItem>
        </ThemeProvider>
      </GridContainer>
    </div>
  )
}
